import { render, staticRenderFns } from "./EditEndorsement.vue?vue&type=template&id=a66223b0&scoped=true"
import script from "./EditEndorsement.vue?vue&type=script&lang=js"
export * from "./EditEndorsement.vue?vue&type=script&lang=js"
import style0 from "./EditEndorsement.vue?vue&type=style&index=0&id=a66223b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66223b0",
  null
  
)

export default component.exports